import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { CheckBox, CheckBoxProps } from '../CheckBox';

export interface SelectionBarProps {
  label?: ReactNode;
  disabled?: boolean;
  className?: string;
  children?: ReactNode;
  checkboxProps?: CheckBoxProps;
  selectAllProps?: { label?: ReactNode; onClick?: () => void; className?: string };
}

export const SelectionBar = ({ children, className, checkboxProps, selectAllProps }: SelectionBarProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn('absolute top-0 left-0 z-7 box-border flex h-12 w-full items-center bg-black-90 px-4', className)}
    >
      {checkboxProps ? (
        <CheckBox
          checked
          className={cn('checkbox-wrapper', checkboxProps?.className)}
          classNames={{ ...checkboxProps?.classNames, label: cn('text-white!', checkboxProps?.classNames?.label) }}
          help={t<string>(checkboxProps?.indeterminate ? 'Select all on this page' : 'Unselect all on this page')}
          {...checkboxProps}
        />
      ) : null}

      {checkboxProps?.indeterminate && !!selectAllProps?.onClick ? (
        <button
          className={cn(
            'ml-4 cursor-pointer text-base font-normal text-white underline',
            'hover:opacity-85 disabled:cursor-not-allowed disabled:opacity-80',
            selectAllProps?.className
          )}
          onClick={selectAllProps.onClick}
          disabled={checkboxProps?.disabled}
        >
          {selectAllProps.label ?? t('Select all items')}
        </button>
      ) : null}

      {children}
    </div>
  );
};
